import React from "react";
import ModuleNavigation from "../ModuleNavigation";

export default function ServiceItemModule() {
  return <ModuleNavigation moduleId="ServiceItemModule" />;
}
